import Vue from 'vue'
import Cookies from 'js-cookie'
import router from './router'
import store from './store'
import i18n from './lang' // Internationalization

import './icons' // icon
import './permission' // permission control

import * as filters from './filters' // global filters

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

/*add element-ui*/
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'

Vue.use(ElementUI, {
    size: Cookies.get('size') || 'default', //set element-ui default size | small | medium
    i18n: (key, value) => i18n.t(key, value), // 国际化需要
})

// register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

/*基于vue的粒子特效插件*/
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

/*引入animate.css*/
import animate from 'animate.css'
Vue.use(animate)

import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

/**引入全局组件*/
import LangSelect from './components/LangSelect'
Vue.component('LangSelect', LangSelect)

import App from './App.vue'

/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false

const vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')

export default vm